import { createApiClient } from '@util/api'

const auth = createApiClient('/patients/auth/')

export const login = () =>
  auth.get('login', {
    params: { origin: window.location.origin + '/' },
  })

export const validate = async (code: string) =>
  auth.post('validate', {
    code: code,
    redirectUri: window.location.origin + '/',
  })

export const refreshToken = async (refreshToken: string) => {
  const request = {
    refreshToken: refreshToken,
  }
  const { data } = await auth.post('refresh_token', request)
  return data
}

export const logout = async (idToken: string) => {
  const request = {
    idToken: idToken,
    redirectUri: window.location.origin + '/',
  }
  const { data } = await auth.post<{ redirect_uri: string }>('logout', request)
  return data
}
export const registration = () =>
  auth.get('registration', {
    params: { origin: window.location.origin + '/' },
  })
